export default {"src":"/_next/static/media/loading.0faf4354.gif","height":120,"width":120,"blurWidth":0,"blurHeight":0};